import { RouteConfig } from 'vue-router';
// models
import Breadcrumbs from './breadcrumbs';

const Home = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Index" */ '@/views/Index');
const Mazadat = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Mazadat" */ '@/views/Mazadat/MazadatList/mazadatList');
const MazadDetails = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "MazadDetails" */ '@/views/Mazadat/MazadDetails/mazadDetails');
const Easar = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "EasarList" */ '@/views/Easar/EasarList/easarList');
const EasarDetails = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "EasarDetails" */ '@/views/Easar/EasarDetails/easarDetails');
const MoneyReservation = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "ReserveMoneyList" */ '@/views/MoneyReservation/MoneyReservationList/moneyReservationList');
const MoneyReservationDetails = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "MoneyReservationDetails" */ '@/views/MoneyReservation/MoneyReservationDetails/moneyReservationDetails');
const ProvenEasarList = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "ProvenEasarList" */ '@/views/Easar/ProvenEasarList/provenEasarList');

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/mazadat',
    name: 'mazadat',
    component: Mazadat,
    meta: {
      breadcrumb: Breadcrumbs.mazadat,
    },
  },

  {
    path: '/mazad-details/:category/:id',
    name: 'mazadDetails',
    component: MazadDetails,
    props: true,
    meta: {
      breadcrumb: Breadcrumbs.mazadDetails,
    },
  },
  {
    path: '/easar',
    name: 'easar',
    component: Easar,
    meta: {
      breadcrumb: Breadcrumbs.easarLists,
    },
  },
  {
    path: '/easar-details/:id',
    name: 'easarDetails',
    component: EasarDetails,
    props: true,
    meta: {
      breadcrumb: Breadcrumbs.easarDetails,
    },
  },
  {
    path: '/money-reservation',
    name: 'moneyReservation',
    component: MoneyReservation,
    meta: {
      breadcrumb: Breadcrumbs.moneyReservation,
    },
  },
  {
    path: '/money-reservation/:requestNo',
    name: 'moneyReservationDetails',
    component: MoneyReservationDetails,
    props: true,
    meta: {
      breadcrumb: Breadcrumbs.moneyReservationDetails,
    },
  },
  {
    path: '/easar-proven',
    name: 'provenEasarList',
    component: ProvenEasarList,
    meta: {
      breadcrumb: Breadcrumbs.provenEasarList,
    },
  },
];
export default routes;
